import { render, staticRenderFns } from "./vs-button.vue?vue&type=template&id=53345ef7"
import script from "./vs-button.vue?vue&type=script&lang=js"
export * from "./vs-button.vue?vue&type=script&lang=js"
import style0 from "./vs-button.vue?vue&type=style&index=0&id=53345ef7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports